(function() {
  "use strict";
  const VERSAO = "v7";
  if (window.BSSlideCart && window.BSSlideCart.version === VERSAO) {
    return;
  }
  const DOMINIO_YAMPI = "https://seguro.biosante.com.br";
  const STORAGE_KEY = "biosante_cart_v3";
  const CART_TTL_MS = 30 * 24 * 60 * 60 * 1e3;
  const COOKIE_COMPRA_OK = "bs988_compra_ok";
  const COOKIE_DOMAIN_BASE = ".biosante.com.br";
  const ATTR_COOKIE = "bs988_attr";
  const ATTR_TTL_MS = 90 * 24 * 60 * 60 * 1e3;
  const ATTR_UTMS = [ "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term" ];
  const ATTR_METADATA = [ "bemob_cid", "fbclid", "campaign_id", "adset_id", "ad_id" ];
  const ATTR_MAX_VALOR = 150;
  const ATTR_MAX_COOKIE = 3800;
  const ATTR_MAX_QUERY = 1200;
  const SVG_LIXEIRA = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false"><path d="M4.66666 14C4.3 14 3.98611 13.8694 3.725 13.6083C3.46389 13.3472 3.33333 13.0333 3.33333 12.6667V4H2.66666V2.66667H6V2H10V2.66667H13.3333V4H12.6667V12.6667C12.6667 13.0333 12.5361 13.3472 12.275 13.6083C12.0139 13.8694 11.7 14 11.3333 14H4.66666ZM11.3333 4H4.66666V12.6667H11.3333V4ZM6 11.3333H7.33333V5.33333H6V11.3333ZM8.66666 11.3333H10V5.33333H8.66666V11.3333Z"/></svg>';
  const COR_CTA = "#23A455";
  const COR_TEXTO = "#111";
  const COR_BORDA = "#e5e5e5";
  const COR_BADGE_ROSA = "#d4258e";
  const QTY_MAX_POR_SKU = 10;
  const FRETE_GRATIS_META_REAIS = 200;
  const TIMER_SEGUNDOS = 15 * 60;
  const BREAKPOINT_MOBILE_PX = 480;
  const PARCELAS_MAX = 12;
  const FATOR_PARCELAMENTO = 1.2241;
  const DESCONTO_ASSINATURA = .1;
  const CUPOM_PADRAO = "";
  const DEBUG = function() {
    const h = location.hostname;
    return h === "localhost" || h === "127.0.0.1" || location.protocol === "file:" || h.endsWith(".myshopify.com");
  }();
  const log = DEBUG ? function() {
    console.log.apply(console, [ "[bs-cart]" ].concat([].slice.call(arguments)));
  } : function() {};
  const warn = function() {
    console.warn.apply(console, [ "[bs-cart]" ].concat([].slice.call(arguments)));
  };
  if (window.Shopify && window.Shopify.designMode) {
    console.log("[bs-cart] Theme Editor detectado — slidecart desativado.");
    window.BSSlideCart = {
      version: VERSAO,
      supported: false,
      reason: "theme-editor"
    };
    return;
  }
  var PRODUTOS = {
    KITAV20: {
      nome: "1un Avane Skin Frutas Vermelhas",
      preco: 187,
      de: 187,
      qty: 1,
      familia: "avane",
      token: "5WQYBTIR1T",
      meta_id: "206271",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-1un-frutas-vermelhas-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-1un-frutas-vermelhas-480.webp"
    },
    KITAV21: {
      nome: "1un Avane Skin Neutro",
      preco: 187,
      de: 187,
      qty: 1,
      familia: "avane",
      token: "THQL83HU5U",
      meta_id: "3804920",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-1un-neutro-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-1un-neutro-480.webp"
    },
    KITAV22: {
      nome: "1un Avane Skin Abacaxi com Limão",
      preco: 187,
      de: 187,
      qty: 1,
      familia: "avane",
      token: "DT054P0MN1",
      meta_id: "14680334",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-1un-abacaxi-limao-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-1un-abacaxi-limao-480.webp"
    },
    KITAV24: {
      nome: "1un Avane Skin Pêssego com Tangerina",
      preco: 187,
      de: 187,
      qty: 1,
      familia: "avane",
      token: "RPNT5JQQJX",
      meta_id: "63788126",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-1un-pessego-tangerina-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-1un-pessego-tangerina-480.webp"
    },
    KITAV104: {
      nome: "2un Avane Skin Frutas Vermelhas",
      preco: 354,
      de: 187,
      qty: 2,
      familia: "avane",
      token: "SQZ8KTTEEC",
      meta_id: "283330562",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-2un-neutro-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-2un-neutro-480.webp"
    },
    KITAV105: {
      nome: "2un Avane Skin: 1 Frutas Vermelhas + 1 Pêssego com Tangerina",
      preco: 354,
      de: 187,
      qty: 2,
      familia: "avane",
      token: "L2P2ZNC8K3",
      meta_id: "283330599",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-2un-neutro-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-2un-neutro-480.webp"
    },
    KITAV106: {
      nome: "2un Avane Skin Pêssego com Tangerina",
      preco: 354,
      de: 187,
      qty: 2,
      familia: "avane",
      token: "D6MZSG56K2",
      meta_id: "283330633",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-2un-neutro-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-2un-neutro-480.webp"
    },
    KITAV107: {
      nome: "2un Avane Skin Abacaxi com Limão",
      preco: 354,
      de: 187,
      qty: 2,
      familia: "avane",
      token: "NKN5VMMQZ9",
      meta_id: "283332168",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-2un-neutro-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-2un-neutro-480.webp"
    },
    KITAV108: {
      nome: "2un Avane Skin Neutro",
      preco: 354,
      de: 187,
      qty: 2,
      familia: "avane",
      token: "3LN3C8QKTA",
      meta_id: "283332232",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-2un-neutro-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-2un-neutro-480.webp"
    },
    KITAV12: {
      nome: "3un Avane Skin: 1 Frutas Vermelhas + 1 Pêssego com Tangerina + 1 Abacaxi com Limão",
      preco: 471,
      de: 187,
      qty: 3,
      familia: "avane",
      token: "IMUIT9HSJH",
      meta_id: "64029235",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-3un-mix-1fv-1pt-1al-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-3un-mix-1fv-1pt-1al-480.webp"
    },
    KITAV14: {
      nome: "3un Avane Skin Frutas Vermelhas",
      preco: 471,
      de: 187,
      qty: 3,
      familia: "avane",
      token: "M5QYQ6PA22",
      meta_id: "64029358",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-3un-frutas-vermelhas-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-3un-frutas-vermelhas-480.webp"
    },
    KITAV15: {
      nome: "3un Avane Skin Abacaxi com Limão",
      preco: 471,
      de: 187,
      qty: 3,
      familia: "avane",
      token: "LKTWEF7TE9",
      meta_id: "64029373",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-3un-abacaxi-limao-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-3un-abacaxi-limao-480.webp"
    },
    KITAV16: {
      nome: "3un Avane Skin Pêssego com Tangerina",
      preco: 471,
      de: 187,
      qty: 3,
      familia: "avane",
      token: "8HOME557I3",
      meta_id: "64029408",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-3un-pessego-tangerina-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-3un-pessego-tangerina-480.webp"
    },
    KITAV18: {
      nome: "3un Avane Skin Neutro",
      preco: 471,
      de: 187,
      qty: 3,
      familia: "avane",
      token: "J2LNDBZY3J",
      meta_id: "64029453",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-3un-neutro-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-3un-neutro-480.webp"
    },
    KITAV1: {
      nome: "5un Avane Skin: 2 Frutas Vermelhas + 2 Abacaxi com Limão + 1 Pêssego com Tangerina",
      preco: 635,
      de: 187,
      qty: 5,
      familia: "avane",
      token: "FQQEF0Q2SL",
      meta_id: "64021799",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-5un-mix-2fv-2al-1pt-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-5un-mix-2fv-2al-1pt-480.webp"
    },
    KITAV11: {
      nome: "5un Avane Skin Neutro",
      preco: 635,
      de: 187,
      qty: 5,
      familia: "avane",
      token: "DVC386A1N3",
      meta_id: "64022090",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-5un-neutro-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-5un-neutro-480.webp"
    },
    KITAV3: {
      nome: "5un Avane Skin: 3 Frutas Vermelhas + 2 Abacaxi com Limão",
      preco: 635,
      de: 187,
      qty: 5,
      familia: "avane",
      token: "LPP3CXUNRK",
      meta_id: "64021920",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-5un-mix-3fv-2al-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-5un-mix-3fv-2al-480.webp"
    },
    KITAV4: {
      nome: "5un Avane Skin: 3 Frutas Vermelhas + 2 Pêssego com Tangerina",
      preco: 635,
      de: 187,
      qty: 5,
      familia: "avane",
      token: "J9V73USII3",
      meta_id: "64021923",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-5un-neutro-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-5un-neutro-480.webp"
    },
    KITAV5: {
      nome: "5un Avane Skin: 3 Abacaxi com Limão + 2 Pêssego com Tangerina",
      preco: 635,
      de: 187,
      qty: 5,
      familia: "avane",
      token: "DF3NA3LLVQ",
      meta_id: "64021927",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-5un-mix-3al-2pt-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-5un-mix-3al-2pt-480.webp"
    },
    KITAV7: {
      nome: "5un Avane Skin Frutas Vermelhas",
      preco: 635,
      de: 187,
      qty: 5,
      familia: "avane",
      token: "OUMYBJHFN8",
      meta_id: "64021987",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-5un-frutas-vermelhas-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-5un-frutas-vermelhas-480.webp"
    },
    KITAV8: {
      nome: "5un Avane Skin Abacaxi com Limão",
      preco: 635,
      de: 187,
      qty: 5,
      familia: "avane",
      token: "DCB220B9YH",
      meta_id: "64022019",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-5un-abacaxi-limao-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-5un-abacaxi-limao-480.webp"
    },
    KITAV9: {
      nome: "5un Avane Skin Pêssego com Tangerina",
      preco: 635,
      de: 187,
      qty: 5,
      familia: "avane",
      token: "G20HN1LXNU",
      meta_id: "64022055",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-5un-pessego-tangerina-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-5un-pessego-tangerina-480.webp"
    },
    KITAV61: {
      nome: "6un Avane Skin: 2 Frutas Vermelhas + 2 Abacaxi com Limão + 2 Pêssego com Tangerina",
      preco: 762,
      de: 187,
      qty: 6,
      familia: "avane",
      token: "8SKR0GWB7Q",
      meta_id: "135414947",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-6un-mix-2fv-2al-2pt-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-6un-mix-2fv-2al-2pt-480.webp"
    },
    KITAV611: {
      nome: "6un Avane Skin Neutro",
      preco: 762,
      de: 187,
      qty: 6,
      familia: "avane",
      token: "C23SOGL6TW",
      meta_id: "135432589",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-6un-neutro-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-6un-neutro-480.webp"
    },
    KITAV63: {
      nome: "6un Avane Skin: 3 Frutas Vermelhas + 3 Abacaxi com Limão",
      preco: 762,
      de: 187,
      qty: 6,
      familia: "avane",
      token: "7SIEAB44Y7",
      meta_id: "135431010",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-6un-mix-3fv-3al-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-6un-mix-3fv-3al-480.webp"
    },
    KITAV64: {
      nome: "6un Avane Skin: 3 Frutas Vermelhas + 3 Pêssego com Tangerina",
      preco: 762,
      de: 187,
      qty: 6,
      familia: "avane",
      token: "H0LDAAFHBH",
      meta_id: "135432794",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-6un-neutro-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-6un-neutro-480.webp"
    },
    KITAV65: {
      nome: "6un Avane Skin: 3 Abacaxi com Limão + 3 Pêssego com Tangerina",
      preco: 762,
      de: 187,
      qty: 6,
      familia: "avane",
      token: "HD9PQYGUDL",
      meta_id: "135433093",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-6un-mix-3al-3pt-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-6un-mix-3al-3pt-480.webp"
    },
    KITAV67: {
      nome: "6un Avane Skin Frutas Vermelhas",
      preco: 762,
      de: 187,
      qty: 6,
      familia: "avane",
      token: "D3VAQ618IO",
      meta_id: "135430773",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-6un-frutas-vermelhas-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-6un-frutas-vermelhas-480.webp"
    },
    KITAV77: {
      nome: "6un Avane Skin Abacaxi com Limão",
      preco: 762,
      de: 187,
      qty: 6,
      familia: "avane",
      token: "59C40LVC49",
      meta_id: "255015550",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-6un-abacaxi-limao-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-6un-abacaxi-limao-480.webp"
    },
    KITAV78: {
      nome: "6un Avane Skin Pêssego com Tangerina",
      preco: 762,
      de: 187,
      qty: 6,
      familia: "avane",
      token: "2WEY6OV1HL",
      meta_id: "255015720",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-6un-pessego-tangerina-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-6un-pessego-tangerina-480.webp"
    },
    KITAVT12: {
      nome: "8un Avane Skin: 4 Frutas Vermelhas + 4 Abacaxi com Limão",
      preco: 936,
      de: 187,
      qty: 8,
      familia: "avane",
      token: "LRLSVS6IZT",
      meta_id: "194329231",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-8un-neutro-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-8un-neutro-480.webp"
    },
    KITAVT13: {
      nome: "8un Avane Skin: 4 Frutas Vermelhas + 4 Pêssego com Tangerina",
      preco: 936,
      de: 187,
      qty: 8,
      familia: "avane",
      token: "O6ZOD7M0K2",
      meta_id: "194333032",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-8un-neutro-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-8un-neutro-480.webp"
    },
    KITAVT14: {
      nome: "8un Avane Skin Neutro",
      preco: 936,
      de: 187,
      qty: 8,
      familia: "avane",
      token: "2RFRA9CB3H",
      meta_id: "194334919",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-8un-neutro-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-8un-neutro-480.webp"
    },
    KITAVT15: {
      nome: "8un Avane Skin Frutas Vermelhas",
      preco: 936,
      de: 187,
      qty: 8,
      familia: "avane",
      token: "DGSG0YJ62M",
      meta_id: "194336971",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-8un-frutas-vermelhas-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-8un-frutas-vermelhas-480.webp"
    },
    KITAVT16: {
      nome: "8un Avane Skin Abacaxi com Limão",
      preco: 936,
      de: 187,
      qty: 8,
      familia: "avane",
      token: "HUH1LQLGGF",
      meta_id: "194337959",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-8un-abacaxi-limao-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-8un-abacaxi-limao-480.webp"
    },
    KITAVT18: {
      nome: "8un Avane Skin Pêssego com Tangerina",
      preco: 936,
      de: 187,
      qty: 8,
      familia: "avane",
      token: "9JYLLLWNX9",
      meta_id: "194338213",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-8un-pessego-tangerina-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-8un-pessego-tangerina-480.webp"
    },
    KITAVT20: {
      nome: "8un Avane Skin: 4 Pêssego com Tangerina + 4 Abacaxi com Limão",
      preco: 936,
      de: 187,
      qty: 8,
      familia: "avane",
      token: "9NA764KIIR",
      meta_id: "194338774",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/avane/avane-8un-neutro-160.webp",
      h: "https://cdn-media.biosante.com.br/avane/avane-8un-neutro-480.webp"
    },
    KITBU1: {
      nome: "1un Vitamina B12 Pulse",
      preco: 91,
      de: 91,
      qty: 1,
      familia: "b12",
      token: "A0TP3NHTKM",
      meta_id: "168126419",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/vitamina-b12/b12-1un-160.webp",
      h: "https://cdn-media.biosante.com.br/vitamina-b12/b12-1un-480.webp"
    },
    KITBU2: {
      nome: "3un Vitamina B12 Pulse",
      preco: 182,
      de: 91,
      qty: 3,
      familia: "b12",
      token: "GCRI4QVZL5",
      meta_id: "168911323",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/vitamina-b12/b12-3un-160.webp",
      h: "https://cdn-media.biosante.com.br/vitamina-b12/b12-3un-480.webp"
    },
    KITBU3: {
      nome: "5un Vitamina B12 Pulse",
      preco: 273,
      de: 91,
      qty: 5,
      familia: "b12",
      token: "A4XKXLY3A8",
      meta_id: "168911322",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/vitamina-b12/b12-5un-160.webp",
      h: "https://cdn-media.biosante.com.br/vitamina-b12/b12-5un-480.webp"
    },
    KITBU4: {
      nome: "8un Vitamina B12 Pulse",
      preco: 312,
      de: 91,
      qty: 8,
      familia: "b12",
      token: "N5V1NXAYY0",
      meta_id: "276521786",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/vitamina-b12/b12-8un-160.webp",
      h: "https://cdn-media.biosante.com.br/vitamina-b12/b12-8un-480.webp"
    },
    BIO0069: {
      nome: "1un Biojoint Colágeno Tipo 2",
      preco: 154,
      de: 154,
      qty: 1,
      familia: "biojoint",
      token: "8JCV9P6SIW",
      meta_id: "283221544",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/biojoint/biojoint-1un-160.webp",
      h: "https://cdn-media.biosante.com.br/biojoint/biojoint-1un-480.webp"
    },
    KITBJ03: {
      nome: "3un Biojoint Colágeno Tipo 2",
      preco: 308,
      de: 154,
      qty: 3,
      familia: "biojoint",
      token: "JUG84X4MRT",
      meta_id: "283221555",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/biojoint/biojoint-3un-160.webp",
      h: "https://cdn-media.biosante.com.br/biojoint/biojoint-3un-480.webp"
    },
    KITBJ05: {
      nome: "5un Biojoint Colágeno Tipo 2",
      preco: 460,
      de: 154,
      qty: 5,
      familia: "biojoint",
      token: "HE4R237ZK4",
      meta_id: "283221622",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/biojoint/biojoint-5un-160.webp",
      h: "https://cdn-media.biosante.com.br/biojoint/biojoint-5un-480.webp"
    },
    COE001: {
      nome: "1un Coenzima Q10",
      preco: 87,
      de: 87,
      qty: 1,
      familia: "coq10",
      token: "4RWOMCIMY6",
      meta_id: "281304310",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/coenzima-q10/q10-1un-160.webp",
      h: "https://cdn-media.biosante.com.br/coenzima-q10/q10-1un-480.webp"
    },
    COE003: {
      nome: "3un Coenzima Q10",
      preco: 216,
      de: 87,
      qty: 3,
      familia: "coq10",
      token: "E3XSWX0E1E",
      meta_id: "281304436",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/coenzima-q10/q10-3un-160.webp",
      h: "https://cdn-media.biosante.com.br/coenzima-q10/q10-3un-480.webp"
    },
    COE005: {
      nome: "5un Coenzima Q10",
      preco: 295,
      de: 87,
      qty: 5,
      familia: "coq10",
      token: "NS076MIT2Z",
      meta_id: "281304447",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/coenzima-q10/q10-5un-160.webp",
      h: "https://cdn-media.biosante.com.br/coenzima-q10/q10-5un-480.webp"
    },
    KITCB1: {
      nome: "1un Cranberry Optima",
      preco: 137,
      de: 137,
      qty: 1,
      familia: "cranberry",
      token: "3G26BCLXIV",
      meta_id: "150374510",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/cranberry/cranberry-1un-160.webp",
      h: "https://cdn-media.biosante.com.br/cranberry/cranberry-1un-480.webp"
    },
    KITCB2: {
      nome: "3un Cranberry Optima",
      preco: 266,
      de: 137,
      qty: 3,
      familia: "cranberry",
      token: "LB1PKG40DX",
      meta_id: "150375183",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/cranberry/cranberry-3un-160.webp",
      h: "https://cdn-media.biosante.com.br/cranberry/cranberry-3un-480.webp"
    },
    KITCB3: {
      nome: "5un Cranberry Optima",
      preco: 295,
      de: 137,
      qty: 5,
      familia: "cranberry",
      token: "SAD9BTZZ9G",
      meta_id: "150376120",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/cranberry/cranberry-5un-160.webp",
      h: "https://cdn-media.biosante.com.br/cranberry/cranberry-5un-480.webp"
    },
    KITCB4: {
      nome: "8un Cranberry Optima",
      preco: 376,
      de: 137,
      qty: 8,
      familia: "cranberry",
      token: "9RI7GMUJI3",
      meta_id: "276570201",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/cranberry/cranberry-8un-160.webp",
      h: "https://cdn-media.biosante.com.br/cranberry/cranberry-8un-480.webp"
    },
    CUR001: {
      nome: "1un Cúrcuma Ultra",
      preco: 107,
      de: 107,
      qty: 1,
      familia: "curcuma",
      token: "BOP5DAVZGX",
      meta_id: "281303357",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/curcuma/curcuma-1un-160.webp",
      h: "https://cdn-media.biosante.com.br/curcuma/curcuma-1un-480.webp"
    },
    CUR003: {
      nome: "3un Cúrcuma Ultra",
      preco: 216,
      de: 107,
      qty: 3,
      familia: "curcuma",
      token: "51NT4HYE4R",
      meta_id: "281303456",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/curcuma/curcuma-3un-160.webp",
      h: "https://cdn-media.biosante.com.br/curcuma/curcuma-3un-480.webp"
    },
    CUR005: {
      nome: "5un Cúrcuma Ultra",
      preco: 285,
      de: 107,
      qty: 5,
      familia: "curcuma",
      token: "J5N8V0BA1S",
      meta_id: "281303503",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/curcuma/curcuma-5un-160.webp",
      h: "https://cdn-media.biosante.com.br/curcuma/curcuma-5un-480.webp"
    },
    NAC001: {
      nome: "1un NAC N-acetilcisteína",
      preco: 64,
      de: 64,
      qty: 1,
      familia: "nac",
      token: "PC8T1Y1G6E",
      meta_id: "281286774",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/nac/nac-1un-160.webp",
      h: "https://cdn-media.biosante.com.br/nac/nac-1un-480.webp"
    },
    NAC003: {
      nome: "3un NAC N-acetilcisteína",
      preco: 171,
      de: 64,
      qty: 3,
      familia: "nac",
      token: "FJXD9O6GQD",
      meta_id: "281304141",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/nac/nac-3un-160.webp",
      h: "https://cdn-media.biosante.com.br/nac/nac-3un-480.webp"
    },
    NAC005: {
      nome: "5un NAC N-acetilcisteína",
      preco: 245,
      de: 64,
      qty: 5,
      familia: "nac",
      token: "EAQOKORUOI",
      meta_id: "281304145",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/nac/nac-5un-160.webp",
      h: "https://cdn-media.biosante.com.br/nac/nac-5un-480.webp"
    },
    KITPV1: {
      nome: "1un Própolis Verde",
      preco: 87,
      de: 87,
      qty: 1,
      familia: "propolis",
      token: "CD5WVZXW31",
      meta_id: "168663395",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/propolis/propolis-1un-160.webp",
      h: "https://cdn-media.biosante.com.br/propolis/propolis-1un-480.webp"
    },
    KITPV2: {
      nome: "3un Própolis Verde",
      preco: 231,
      de: 87,
      qty: 3,
      familia: "propolis",
      token: "OC6YPL5DQZ",
      meta_id: "168912377",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/propolis/propolis-3un-160.webp",
      h: "https://cdn-media.biosante.com.br/propolis/propolis-3un-480.webp"
    },
    KITPV3: {
      nome: "5un Própolis Verde",
      preco: 285,
      de: 87,
      qty: 5,
      familia: "propolis",
      token: "FC5L0C3DM4",
      meta_id: "168912376",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/propolis/propolis-5un-160.webp",
      h: "https://cdn-media.biosante.com.br/propolis/propolis-5un-480.webp"
    },
    KITSH20: {
      nome: "1un Silic Hair Silício Orgânico",
      preco: 174,
      de: 174,
      qty: 1,
      familia: "silic",
      token: "MR5BSBYGK3",
      meta_id: "168915831",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/silic-hair/silic-hair-1un-160.webp",
      h: "https://cdn-media.biosante.com.br/silic-hair/silic-hair-1un-480.webp"
    },
    KITSH1: {
      nome: "3un Silic Hair Silício Orgânico",
      preco: 348,
      de: 174,
      qty: 3,
      familia: "silic",
      token: "L4BY8WW19Z",
      meta_id: "168127054",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/silic-hair/silic-hair-3un-160.webp",
      h: "https://cdn-media.biosante.com.br/silic-hair/silic-hair-3un-480.webp"
    },
    KITSH2: {
      nome: "5un Silic Hair Silício Orgânico",
      preco: 522,
      de: 174,
      qty: 5,
      familia: "silic",
      token: "G6V0XXRAO4",
      meta_id: "78153462",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/silic-hair/silic-hair-5un-160.webp",
      h: "https://cdn-media.biosante.com.br/silic-hair/silic-hair-5un-480.webp"
    },
    SLH8: {
      nome: "8un Silic Hair Silício Orgânico",
      preco: 796,
      de: 174,
      qty: 8,
      familia: "silic",
      token: "MLCFUA3BU0",
      meta_id: "301711096",
      dias: 30,
      t: "https://cdn-media.biosante.com.br/silic-hair/silic-hair-8un-160.webp",
      h: "https://cdn-media.biosante.com.br/silic-hair/silic-hair-8un-480.webp"
    },
    KITVD1: {
      nome: "1un Vitamina D",
      preco: 77,
      de: 77,
      qty: 1,
      familia: "vitd",
      token: "KQ8B2A7L3D",
      meta_id: "168663397",
      dias: 60,
      t: "https://cdn-media.biosante.com.br/vitamina-d/vitamina-d-1un-160.webp",
      h: "https://cdn-media.biosante.com.br/vitamina-d/vitamina-d-1un-480.webp"
    },
    KITVD3: {
      nome: "3un Vitamina D",
      preco: 201,
      de: 77,
      qty: 3,
      familia: "vitd",
      token: "Q8T3R808S3",
      meta_id: "168911340",
      dias: 60,
      t: "https://cdn-media.biosante.com.br/vitamina-d/vitamina-d-3un-160.webp",
      h: "https://cdn-media.biosante.com.br/vitamina-d/vitamina-d-3un-480.webp"
    },
    KITVD2: {
      nome: "5un Vitamina D",
      preco: 235,
      de: 77,
      qty: 5,
      familia: "vitd",
      token: "GJ4I8879II",
      meta_id: "168911339",
      dias: 60,
      t: "https://cdn-media.biosante.com.br/vitamina-d/vitamina-d-5un-160.webp",
      h: "https://cdn-media.biosante.com.br/vitamina-d/vitamina-d-5un-480.webp"
    }
  };
  var ALIAS = {
    "avane-1p-abacaxi": "KITAV22",
    "avane-1p-frutas": "KITAV20",
    "avane-1p-neutro": "KITAV21",
    "avane-1p-pessego": "KITAV24",
    "avane-2p-abacaxi": "KITAV107",
    "avane-2p-frutas": "KITAV104",
    "avane-2p-misto-fvpt": "KITAV105",
    "avane-2p-neutro": "KITAV108",
    "avane-2p-pessego": "KITAV106",
    "avane-3p-abacaxi": "KITAV15",
    "avane-3p-frutas": "KITAV14",
    "avane-3p-misto": "KITAV12",
    "avane-3p-neutro": "KITAV18",
    "avane-3p-pessego": "KITAV16",
    "avane-5p-abacaxi": "KITAV8",
    "avane-5p-frutas": "KITAV7",
    "avane-5p-misto-abpt": "KITAV5",
    "avane-5p-misto-fvab": "KITAV3",
    "avane-5p-misto-fvab-v2": "KITAV3",
    "avane-5p-misto-fvabpt": "KITAV1",
    "avane-5p-misto-fvpt": "KITAV4",
    "avane-5p-neutro": "KITAV11",
    "avane-5p-pessego": "KITAV9",
    "avane-6p-abacaxi": "KITAV77",
    "avane-6p-frutas": "KITAV67",
    "avane-6p-misto-abpt": "KITAV65",
    "avane-6p-misto-fvab": "KITAV63",
    "avane-6p-misto-fvabpt": "KITAV61",
    "avane-6p-misto-fvpt": "KITAV64",
    "avane-6p-neutro": "KITAV611",
    "avane-6p-pessego": "KITAV78",
    "avane-8p-abacaxi": "KITAVT16",
    "avane-8p-frutas": "KITAVT15",
    "avane-8p-misto-abpt": "KITAVT20",
    "avane-8p-misto-fvab": "KITAVT12",
    "avane-8p-misto-fvpt": "KITAVT13",
    "avane-8p-neutro": "KITAVT14",
    "avane-8p-pessego": "KITAVT18",
    "b12-1p": "KITBU1",
    "b12-3p": "KITBU2",
    "b12-5p": "KITBU3",
    "b12-8p": "KITBU4",
    "biojoint-1p": "BIO0069",
    "biojoint-3p": "KITBJ03",
    "biojoint-5p": "KITBJ05",
    "coq10-1p": "COE001",
    "coq10-3p": "COE003",
    "coq10-5p": "COE005",
    "cranberry-1p": "KITCB1",
    "cranberry-3p": "KITCB2",
    "cranberry-5p": "KITCB3",
    "cranberry-8p": "KITCB4",
    "curcuma-1p": "CUR001",
    "curcuma-3p": "CUR003",
    "curcuma-5p": "CUR005",
    "nac-1p": "NAC001",
    "nac-3p": "NAC003",
    "nac-5p": "NAC005",
    "propolis-1p": "KITPV1",
    "propolis-3p": "KITPV2",
    "propolis-5p": "KITPV3",
    "silic-1p": "KITSH20",
    "silic-3p": "KITSH1",
    "silic-5p": "KITSH2",
    "silic-8p": "SLH8",
    "vitd-1p": "KITVD1",
    "vitd-3p": "KITVD3",
    "vitd-5p": "KITVD2"
  };
  var CUPONS = {
    ANALU10: {
      t: "p",
      v: 10,
      min: 100
    },
    ANONOVO25OFF: {
      t: "v",
      v: 25,
      min: 480
    },
    BIOSANTE15: {
      t: "v",
      v: 15,
      min: 0,
      cod: "biosante15"
    },
    BLACK: {
      t: "p",
      v: 5,
      min: 410
    },
    BLACK25: {
      t: "v",
      v: 25,
      min: 100
    },
    BLACK50: {
      t: "v",
      v: 50,
      min: 200
    },
    BLOG25: {
      t: "v",
      v: 25,
      min: 50
    },
    BRINDEGRATIS: {
      t: "v",
      v: 0,
      min: 300,
      f: 1
    },
    BRINDESGRATIS: {
      t: "v",
      v: 0,
      min: 300,
      f: 1
    },
    CONSUMIDOR25: {
      t: "v",
      v: 25,
      min: 160
    },
    CONSUMIDOR50: {
      t: "v",
      v: 50,
      min: 340
    },
    CURCUMA15: {
      t: "v",
      v: 15,
      min: 50
    },
    DOMINGO50: {
      t: "v",
      v: 50,
      min: 0
    },
    ESPECIAL15: {
      t: "v",
      v: 15,
      min: 0
    },
    FANY50: {
      t: "v",
      v: 50,
      min: 300
    },
    FERIADO50: {
      t: "v",
      v: 50,
      min: 150
    },
    FRETEGRATIS987: {
      t: "v",
      v: 0,
      min: .01,
      f: 1,
      cod: "fretegratis987"
    },
    GANHE27: {
      t: "v",
      v: 27,
      min: 200
    },
    GANHE44: {
      t: "v",
      v: 44,
      min: 300
    },
    GANHE57: {
      t: "v",
      v: 57,
      min: 400
    },
    MAE50: {
      t: "v",
      v: 50,
      min: 300
    },
    MELATONINA15: {
      t: "v",
      v: 15,
      min: 50
    },
    MELHOR50: {
      t: "v",
      v: 50,
      min: 400
    },
    MULHER50: {
      t: "v",
      v: 50,
      min: 400
    },
    NAC25: {
      t: "v",
      v: 25,
      min: 60
    },
    NOVAFORMULA: {
      t: "v",
      v: 50,
      min: 400
    },
    OPTIMA25: {
      t: "v",
      v: 25,
      min: 100
    },
    PAGUE1LEVE2: {
      t: "p",
      v: 50,
      min: 0,
      cod: "pague1leve2"
    },
    PARABENS2025: {
      t: "v",
      v: 50,
      min: 0
    },
    PRESENTE50: {
      t: "v",
      v: 50,
      min: 0
    },
    PRIMEIRA: {
      t: "p",
      v: 5,
      min: 40
    },
    PULSE25: {
      t: "v",
      v: 25,
      min: 100
    },
    QUARTA50: {
      t: "v",
      v: 50,
      min: 400
    },
    QUINTA50: {
      t: "v",
      v: 50,
      min: 400
    },
    "RECOMPRA 10": {
      t: "p",
      v: 10,
      min: 120
    },
    RECOMPRA10: {
      t: "p",
      v: 10,
      min: 120
    },
    SEGUNDA50: {
      t: "v",
      v: 50,
      min: 400
    },
    SEXTA50: {
      t: "v",
      v: 50,
      min: 400
    },
    TERCA50: {
      t: "v",
      v: 50,
      min: 400,
      cod: "TERÇA50"
    },
    TIKTOK: {
      t: "p",
      v: 5,
      min: 0
    },
    VIRADA: {
      t: "p",
      v: 5,
      min: 410
    },
    VOLTE27: {
      t: "v",
      v: 27,
      min: 0
    }
  };
  var SELETORES = {
    avane: {
      1: {
        pid: "9310730911957",
        titulo: "Avane Skin 1un",
        vs: [ [ "53485880049877", "1 Pote Frutas Vermelhas", "KITAV20" ], [ "53485880115413", "1 Pote Abacaxi com Limão", "KITAV22" ], [ "53485880082645", "1 Pote Pêssego com Tangerina", "KITAV24" ], [ "53485880017109", "1 Pote Neutro", "KITAV21" ] ]
      },
      2: {
        pid: "9310731010261",
        titulo: "Avane Skin 2un",
        vs: [ [ "53485882704085", "2 Potes Frutas Vermelhas", "KITAV104" ], [ "53486493499605", "2 Potes - 1un Frutas Vermelhas + 1un Pêssego com Tangerina", "KITAV105" ], [ "53485882769621", "2 Potes Abacaxi com Limão", "KITAV107" ], [ "53485882671317", "2 Potes Neutro", "KITAV108" ], [ "53485882736853", "2 Potes Pêssego com Tangerina", "KITAV106" ] ]
      },
      3: {
        pid: "9310782193877",
        titulo: "Avane Skin 3un",
        vs: [ [ "53486457028821", "3 Potes Frutas Vermelhas", "KITAV14" ], [ "53486491402453", "3 Potes - 1un Frutas Vermelhas + 1un Pêssego com Tangerina + 1un Abacaxi com Limão", "KITAV12" ], [ "53486456996053", "3 Potes Neutro", "KITAV18" ], [ "53486457094357", "3 Potes Abacaxi com Limão", "KITAV15" ], [ "53486457061589", "3 Potes Pêssego com Tangerina", "KITAV16" ] ]
      },
      5: {
        pid: "9310783635669",
        titulo: "Avane Skin 5un",
        vs: [ [ "53486494548181", "5 Potes - 2un Frutas Vermelhas + 2un Abacaxi com Limão + 1un Pêssego com Tangerina", "KITAV1" ], [ "53486494449877", "5 Potes Frutas Vermelhas", "KITAV7" ], [ "53486501560533", "5 Potes - 3un Frutas Vermelhas + 2un Pêssego com Tangerina", "KITAV4" ], [ "53486501527765", "5 Potes - 3un Frutas Vermelhas + 2un Abacaxi com Limão", "KITAV3" ], [ "53486494482645", "5 Potes Pêssego com Tangerina", "KITAV9" ], [ "53486494417109", "5 Potes Neutro", "KITAV11" ], [ "53486494515413", "5 Potes Abacaxi com Limão", "KITAV8" ], [ "53486501593301", "5 Potes - 3un Abacaxi com Limão + 2un Pêssego com Tangerina", "KITAV5" ] ]
      },
      6: {
        pid: "9310788681941",
        titulo: "Avane Skin 6un",
        vs: [ [ "53486529216725", "6 Potes - 2un Frutas Vermelhas + 2un Abacaxi com Limão + 2un Pêssego com Tangerina", "KITAV61" ], [ "53486529118421", "6 Potes Frutas Vermelhas", "KITAV67" ], [ "53486534426837", "6 Potes - 3un Frutas Vermelhas + 3un Pêssego com Tangerina", "KITAV64" ], [ "53486534394069", "6 Potes - 3un Frutas Vermelhas + 3un Abacaxi com Limão", "KITAV63" ], [ "53486529151189", "6 Potes Pêssego com Tangerina", "KITAV78" ], [ "53486529085653", "6 Potes Neutro", "KITAV611" ], [ "53486529183957", "6 Potes Abacaxi com Limão", "KITAV77" ], [ "53486534459605", "6 Potes - 3un Abacaxi com Limão + 3un Pêssego com Tangerina", "KITAV65" ] ]
      },
      8: {
        pid: "9411221979349",
        titulo: "Avane Skin 8un",
        vs: [ [ "54029393264853", "4un Avane Frutas Vermelhas + 4un Avane Pêssego com Tangerina", "KITAVT13" ], [ "54029346341077", "4un Avane Frutas Vermelhas + 4un Avane Abacaxi com Limão", "KITAVT12" ], [ "54029346242773", "8 Potes Frutas Vermelhas", "KITAVT15" ], [ "54029346275541", "8 Potes Pêssego com Tangerina", "KITAVT18" ], [ "54029346210005", "8 Potes Neutro", "KITAVT14" ], [ "54029346308309", "8 Potes Abacaxi com Limão", "KITAVT16" ], [ "54029393297621", "4un Avane Pêssego com Tangerina + 4un Avane Abacaxi com Limão", "KITAVT20" ] ]
      }
    }
  };
  let cupomAplicado = "";
  let cupomResolvido = false;
  let pronto = false;
  let abrirAoPronto = false;
  let degradado = false;
  function resolveSku(chave) {
    if (!chave) return null;
    const k = String(chave).trim();
    if (PRODUTOS[k]) return k;
    const alvo = ALIAS[k];
    return alvo && PRODUTOS[alvo] ? alvo : null;
  }
  function cortaSeguro(s) {
    s = s.slice(0, ATTR_MAX_VALOR);
    const ultimo = s.charCodeAt(s.length - 1);
    if (ultimo >= 55296 && ultimo <= 56319) s = s.slice(0, -1);
    return s;
  }
  function extraiAtribuicaoDaUrl() {
    const d = {};
    try {
      const q = new URLSearchParams(location.search);
      const pega = function(destino, origem) {
        const v = q.get(origem);
        if (typeof v !== "string" || !v.trim()) return;
        const c = cortaSeguro(v.trim());
        if (c) d[destino] = c;
      };
      ATTR_UTMS.forEach(function(k) {
        pega(k, k);
      });
      pega("bemob_cid", "cid");
      pega("bemob_cid", "bemob_cid");
      pega("fbclid", "fbclid");
      pega("campaign_id", "meta_campaign_id");
      pega("adset_id", "meta_adset_id");
      pega("ad_id", "meta_ad_id");
      pega("campaign_id", "campaign_id");
      pega("adset_id", "adset_id");
      pega("ad_id", "ad_id");
    } catch (e) {
      warn("Falha ao ler atribuição da URL:", e);
    }
    return d;
  }
  function apagaAtribuicao() {
    try {
      document.cookie = ATTR_COOKIE + "=; max-age=0; domain=" + COOKIE_DOMAIN_BASE + "; path=/; SameSite=Lax";
      document.cookie = ATTR_COOKIE + "=; max-age=0; path=/; SameSite=Lax";
    } catch (_) {}
  }
  function leAtribuicao() {
    let achou = false;
    try {
      const c = "; " + document.cookie;
      const parts = c.split("; " + ATTR_COOKIE + "=");
      if (parts.length < 2) return null;
      achou = true;
      const obj = JSON.parse(decodeURIComponent(parts[1].split(";")[0]));
      if (!obj || typeof obj !== "object" || obj.v !== 1) throw new Error("shape");
      const at = obj.at;
      if (typeof at !== "number" || !isFinite(at) || at <= 0 || at > Date.now() + 60 * 1e3 || Date.now() - at > ATTR_TTL_MS) {
        throw new Error("carimbo inválido/expirado");
      }
      const d = {};
      ATTR_UTMS.concat(ATTR_METADATA).forEach(function(k) {
        const v = obj.d && obj.d[k];
        if (typeof v !== "string" || !v.trim()) return;
        const c2 = cortaSeguro(v.trim());
        if (c2) d[k] = c2;
      });
      if (!Object.keys(d).length) throw new Error("sem campos válidos");
      return {
        at: at,
        d: d
      };
    } catch (e) {
      if (achou) apagaAtribuicao();
      return null;
    }
  }
  function gravaAtribuicao(d) {
    try {
      const valor = encodeURIComponent(JSON.stringify({
        v: 1,
        at: Date.now(),
        d: d
      }));
      const h = location.hostname;
      const noDominio = h === "biosante.com.br" || h.endsWith(".biosante.com.br");
      let cookie = ATTR_COOKIE + "=" + valor + "; max-age=" + Math.floor(ATTR_TTL_MS / 1e3) + "; path=/; SameSite=Lax";
      if (noDominio) cookie += "; domain=" + COOKIE_DOMAIN_BASE;
      if (location.protocol === "https:") cookie += "; Secure";
      if (cookie.length > ATTR_MAX_COOKIE) {
        warn("Atribuição grande demais pro cookie (" + cookie.length + " bytes) — não gravada.");
        return;
      }
      document.cookie = cookie;
    } catch (e) {
      warn("Falha ao gravar atribuição:", e);
    }
  }
  function resolveAtribuicaoEfetiva(salvo, vivo) {
    if (vivo && vivo.utm_source) return vivo;
    if (salvo) return salvo;
    return vivo || {};
  }
  function capturaAtribuicao() {
    try {
      const vivo = extraiAtribuicaoDaUrl();
      if (!Object.keys(vivo).length) return;
      const attr = leAtribuicao();
      const efetivo = resolveAtribuicaoEfetiva(attr && attr.d, vivo);
      if (efetivo === vivo) gravaAtribuicao(vivo);
    } catch (e) {
      warn("Falha na captura de atribuição:", e);
    }
  }
  function paramsCheckout() {
    let saida;
    try {
      saida = new URLSearchParams;
    } catch (e) {
      warn("URLSearchParams indisponível — checkout segue sem atribuição.", e);
      return null;
    }
    try {
      const attr = leAtribuicao();
      const d = resolveAtribuicaoEfetiva(attr && attr.d, extraiAtribuicaoDaUrl());
      ATTR_UTMS.forEach(function(k) {
        if (d[k]) saida.set(k, d[k]);
      });
      ATTR_METADATA.forEach(function(k) {
        if (d[k]) saida.set("metadata[" + k + "]", d[k]);
      });
      if (saida.toString().length > ATTR_MAX_QUERY) {
        warn("Atribuição longa demais pra URL — enviando só os UTMs.");
        ATTR_METADATA.forEach(function(k) {
          saida.delete("metadata[" + k + "]");
        });
      }
    } catch (e) {
      warn("Falha ao montar atribuição do checkout:", e);
    }
    return saida;
  }
  function urlYampiSingleProduto(chave, qty) {
    const sku = resolveSku(chave);
    const prod = sku && PRODUTOS[sku];
    if (!prod) return null;
    const n = Math.max(1, Math.min(parseInt(qty, 10) || 1, QTY_MAX_POR_SKU));
    const params = paramsCheckout();
    const cupom = cupomAplicado ? codigoParaCheckout(cupomAplicado) : "";
    let q;
    if (params) {
      params.delete("promocode");
      if (cupom) params.set("promocode", cupom);
      q = params.toString();
    } else {
      q = cupom ? "promocode=" + encodeURIComponent(cupom) : "";
    }
    return DOMINIO_YAMPI + "/r/" + encodeURIComponent(prod.token) + ":" + n + (q ? "?" + q : "");
  }
  capturaAtribuicao();
  const SUPORTA_DIALOG = typeof HTMLDialogElement !== "undefined" && typeof HTMLDialogElement.prototype.showModal === "function";
  if (!SUPORTA_DIALOG) {
    warn("Navegador sem <dialog>+showModal(). Fallback ativado.");
    function garanteCupom() {
      if (!cupomResolvido) {
        try {
          resolveCupomInicial();
        } catch (e) {
          warn("cupom no fallback:", e);
        }
      }
    }
    function fallbackAdd(sku, qty) {
      garanteCupom();
      const url = urlYampiSingleProduto(sku, qty);
      if (url) window.location.href = url;
      return !!url;
    }
    const noop = function() {};
    window.BSSlideCart = {
      version: VERSAO,
      supported: false,
      open: noop,
      close: noop,
      add: fallbackAdd,
      remove: noop,
      updateQty: noop,
      clear: noop,
      get: function() {
        return {};
      },
      subtotal: function() {
        return 0;
      },
      totalQty: function() {
        return 0;
      },
      checkout: noop,
      pronto: function() {
        return true;
      },
      urlDe: function(chave, qty) {
        garanteCupom();
        return urlYampiSingleProduto(chave, qty || 1);
      }
    };
    return;
  }
  log("Inicializando slidecart v" + VERSAO + " (DEBUG ON).");
  let estado = null;
  function validaEstado(dados) {
    if (!dados || typeof dados !== "object" || Array.isArray(dados)) return {};
    const limpo = {};
    for (const sku of Object.keys(dados)) {
      if (!PRODUTOS[sku]) continue;
      const qty = parseInt(dados[sku], 10);
      if (!Number.isInteger(qty) || qty < 1) continue;
      limpo[sku] = Math.min(qty, QTY_MAX_POR_SKU);
    }
    return limpo;
  }
  function carregaCarrinho() {
    let dados = null;
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) dados = JSON.parse(raw);
    } catch (e) {
      log("Falha ao ler localStorage. Começando zerado.", e);
      return {};
    }
    if (!dados || typeof dados !== "object") return {};
    const at = typeof dados.at === "number" ? dados.at : 0;
    if (at && Date.now() - at > CART_TTL_MS) {
      log("Carrinho parado há mais de 30 dias — descartando.");
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (_) {}
      return {};
    }
    return validaEstado(dados.itens);
  }
  function salvaCarrinho() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        itens: estado,
        at: Date.now()
      }));
    } catch (e) {
      log("localStorage indisponível — só em memória.", e);
    }
  }
  function addItem(chave, qty) {
    const sku = resolveSku(chave);
    if (!sku) {
      warn("SKU desconhecido (typo na classe do botão ou fora do catálogo?):", chave);
      return false;
    }
    qty = parseInt(qty, 10) || 1;
    const atual = estado[sku] || 0;
    estado[sku] = Math.max(1, Math.min(atual + qty, QTY_MAX_POR_SKU));
    salvaCarrinho();
    log("addItem", chave, sku !== chave ? "(alias → " + sku + ")" : "", "→ qty", estado[sku]);
    return true;
  }
  function removeItem(sku) {
    if (estado[sku] != null) {
      delete estado[sku];
      salvaCarrinho();
      log("removeItem", sku);
    }
  }
  function updateQty(sku, qty) {
    if (estado[sku] == null) return;
    qty = parseInt(qty, 10);
    if (!Number.isInteger(qty) || qty <= 0) {
      removeItem(sku);
      return;
    }
    estado[sku] = Math.min(qty, QTY_MAX_POR_SKU);
    salvaCarrinho();
    log("updateQty", sku, "→", estado[sku]);
  }
  function clearCart() {
    estado = {};
    salvaCarrinho();
    log("clearCart");
  }
  function getCart() {
    try {
      return JSON.parse(JSON.stringify(estado));
    } catch (e) {
      return {};
    }
  }
  function getTotalQty() {
    let total = 0;
    for (const sku of Object.keys(estado)) total += estado[sku];
    return total;
  }
  function getSubtotal() {
    let total = 0;
    for (const sku of Object.keys(estado)) {
      const cfg = PRODUTOS[sku];
      if (cfg && typeof cfg.preco === "number") {
        total += cfg.preco * estado[sku];
      }
    }
    return total;
  }
  function resolveCupomInicial() {
    cupomResolvido = true;
    var origem = "";
    try {
      var p = new URLSearchParams(location.search).get("promocode");
      if (p && p.trim()) {
        cupomAplicado = p.trim().toUpperCase();
        origem = "URL";
      }
    } catch (e) {}
    if (!cupomAplicado) {
      var daPagina = window.BS_CUPOM_PAGINA;
      if (daPagina && String(daPagina).trim()) {
        cupomAplicado = String(daPagina).trim().toUpperCase();
        origem = "BS_CUPOM_PAGINA";
      }
    }
    if (!cupomAplicado && CUPOM_PADRAO) {
      cupomAplicado = String(CUPOM_PADRAO).trim().toUpperCase();
      origem = "global";
    }
    if (cupomAplicado) log("Cupom inicial:", cupomAplicado, "(origem:", origem + ")");
    validaCupomDaPagina();
  }
  function validaCupomDaPagina() {
    var descontoCard = Number(window.BS_CUPOM_CARD_DESCONTO) || 0;
    var regra = cupomAplicado ? CUPONS[normalizaCupom(cupomAplicado)] : null;
    if (descontoCard > 0 && !cupomAplicado) {
      console.error("[bs-cart] A página abate R$ " + descontoCard + " no preço do card, mas nenhum " + "cupom foi resolvido. O cliente verá um preço e pagará outro. " + "Verifique o CUPOM_PADRAO da theme section.");
      return;
    }
    if (cupomAplicado && !regra) {
      console.error("[bs-cart] Cupom '" + cupomAplicado + "' não está na lista de ativos. " + "Pode ter expirado na Yampi — o checkout vai recusá-lo.");
      return;
    }
    if (regra && descontoCard > 0 && regra.t === "v" && Number(regra.v) !== descontoCard) {
      console.error("[bs-cart] Divergência: o card abate R$ " + descontoCard + " mas o cupom " + cupomAplicado + " vale R$ " + regra.v + ".");
    }
  }
  function normalizaCupom(codigo) {
    if (!codigo) return "";
    var s = String(codigo).trim().toUpperCase();
    try {
      s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    } catch (e) {}
    return s;
  }
  function codigoParaCheckout(codigo) {
    var r = CUPONS[normalizaCupom(codigo)];
    return r && r.cod ? r.cod : String(codigo || "").trim();
  }
  function statusCupom(codigo) {
    if (!codigo) return {
      estado: "vazio",
      desconto: 0
    };
    var r = CUPONS[normalizaCupom(codigo)];
    if (!r) return {
      estado: "desconhecido",
      desconto: 0
    };
    var sub = getSubtotal();
    var min = Number(r.min) || 0;
    if (min > 0 && sub < min) {
      return {
        estado: "minimo",
        desconto: 0,
        minimo: min,
        falta: min - sub
      };
    }
    if (r.f && !Number(r.v)) return {
      estado: "frete",
      desconto: 0
    };
    var bruto = r.t === "p" ? sub * (Number(r.v) || 0) / 100 : Number(r.v) || 0;
    return {
      estado: "ok",
      desconto: Math.max(0, Math.min(bruto, sub))
    };
  }
  function descontoDoCupom(codigo) {
    return statusCupom(codigo).desconto;
  }
  function getSubtotalLiquido() {
    return Math.max(0, getSubtotal() - descontoDoCupom(cupomAplicado));
  }
  estado = carregaCarrinho();
  log("Estado inicial:", estado);
  function leuCompraOkCookie() {
    try {
      const c = "; " + document.cookie;
      const parts = c.split("; " + COOKIE_COMPRA_OK + "=");
      if (parts.length < 2) return false;
      const valor = parts[1].split(";")[0];
      return valor === "1";
    } catch (e) {
      return false;
    }
  }
  function limpaCompraOkCookie() {
    try {
      document.cookie = COOKIE_COMPRA_OK + "=; max-age=0; domain=" + COOKIE_DOMAIN_BASE + "; path=/; SameSite=Lax; Secure";
      document.cookie = COOKIE_COMPRA_OK + "=; max-age=0; path=/; SameSite=Lax; Secure";
    } catch (_) {}
  }
  function processaPostCheckout() {
    if (leuCompraOkCookie()) {
      log("Pedido gerado na Yampi (cookie) — limpando cart.");
      clearCart();
      limpaCompraOkCookie();
      return true;
    }
    return false;
  }
  function fbqEvento(evento, sku, qty) {
    if (typeof window.fbq !== "function") return;
    const p = PRODUTOS[sku];
    if (!p || !p.meta_id) return;
    try {
      window.fbq("track", evento, {
        content_ids: [ p.meta_id ],
        content_type: "product_group",
        content_name: p.nome,
        value: Math.round(p.preco * (qty || 1) * 100) / 100,
        currency: "BRL"
      });
    } catch (e) {
      warn("fbq falhou (" + evento + "):", e);
    }
  }
  const vcDisparados = {};
  function viewContentPagina(chaves) {
    if (!chaves || !chaves.length) return;
    for (let i = 0; i < chaves.length; i++) {
      const sku = resolveSku(chaves[i]);
      if (sku && !vcDisparados[sku]) {
        vcDisparados[sku] = true;
        fbqEvento("ViewContent", sku, 1);
      }
    }
  }
  function trackAddToCart(chave, qty) {
    const sku = resolveSku(chave);
    if (sku) fbqEvento("AddToCart", sku, qty || 1);
  }
  const CSS_TEMPLATE = `\n    /* O CSS abaixo passou a valer em TODAS as páginas do site (o motor agora\n       vive no tema, não em cada theme section). Duas regras que antes eram\n       globais foram escopadas:\n\n       1. o hide do app SlideCart HQ saiu daqui — o app está sendo desinstalado\n       2. o scrollbar-gutter só vale com o drawer aberto (via .bs988-cart-aberto\n          no <html>), pra não deslocar o layout de home, blog e coleções.       */\n\n    /* Reserva o espaço da scrollbar ENQUANTO o drawer está aberto.\n       Sem isso, quando o body vira position:fixed a scrollbar some e o\n       conteúdo se recentraliza ~7-8px pra direita, causando um shift visível. */\n    html.bs988-cart-aberto { scrollbar-gutter: stable; }\n\n    /* Variáveis de tema — escopadas pra não vazar */\n    .bs988-cart-drawer,\n    .bs988-open-cart {\n      --bs988-cor-cta:          ${COR_CTA};\n      --bs988-cor-cta-fundo:    #f5faf6;\n      --bs988-cor-texto:        ${COR_TEXTO};\n      --bs988-cor-borda:        ${COR_BORDA};\n      --bs988-cor-cinza-claro:  #f5f5f5;\n      --bs988-cor-cinza:        #888;\n      --bs988-cor-badge-rosa:   ${COR_BADGE_ROSA};\n      --bs988-anim:             0.3s ease;\n    }\n\n    /* ====== Drawer (dialog nativo) ====== */\n    .bs988-cart-drawer {\n      box-sizing: border-box;\n      padding: 0;\n      border: 0;\n      margin: 0;\n      max-width: 100%;\n      max-height: 100%;\n      width: 420px;\n      /* Fallback pra Chrome 37-107 que tem <dialog> mas não suporta dvh.\n         Browsers modernos sobrescrevem com 100dvh (ajusta a barras mobile). */\n      height: 100vh;\n      height: 100dvh;\n      position: fixed;\n      right: 0;\n      top: 0;\n      left: auto;\n      background: #fff;\n      color: var(--bs988-cor-texto);\n      font-family: inherit;\n      display: flex;\n      flex-direction: column;\n\n      /* Animação de entrada/saída via @starting-style + allow-discrete */\n      translate: 100% 0;\n      opacity: 0;\n      transition:\n        translate var(--bs988-anim),\n        opacity   var(--bs988-anim),\n        display   var(--bs988-anim) allow-discrete,\n        overlay   var(--bs988-anim) allow-discrete;\n    }\n    .bs988-cart-drawer[open] {\n      translate: 0 0;\n      opacity: 1;\n    }\n    @starting-style {\n      .bs988-cart-drawer[open] {\n        translate: 100% 0;\n        opacity: 0;\n      }\n    }\n    .bs988-cart-drawer::backdrop {\n      background: rgba(0, 0, 0, 0.45);\n      opacity: 0;\n      transition:\n        opacity var(--bs988-anim),\n        display var(--bs988-anim) allow-discrete,\n        overlay var(--bs988-anim) allow-discrete;\n    }\n    .bs988-cart-drawer[open]::backdrop { opacity: 1; }\n    @starting-style {\n      .bs988-cart-drawer[open]::backdrop { opacity: 0; }\n    }\n    .bs988-cart-drawer *,\n    .bs988-cart-drawer *::before,\n    .bs988-cart-drawer *::after {\n      box-sizing: border-box;\n    }\n    @media (max-width: ${BREAKPOINT_MOBILE_PX}px) {\n      .bs988-cart-drawer { width: 100%; }\n    }\n\n    /* ====== Header ====== */\n    .bs988-cart-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 16px 20px;\n      border-bottom: 1px solid var(--bs988-cor-borda);\n      flex-shrink: 0;\n    }\n    .bs988-cart-title {\n      font-size: 18px;\n      font-weight: 600;\n      margin: 0;\n    }\n    .bs988-cart-close {\n      background: none;\n      border: 0;\n      padding: 4px 8px;\n      cursor: pointer;\n      font-size: 22px;\n      line-height: 1;\n      color: var(--bs988-cor-texto);\n    }\n\n    /* ====== Frete grátis bar ====== */\n    .bs988-cart-frete-bar {\n      padding: 12px 20px;\n      background: var(--bs988-cor-cta-fundo);\n      text-align: center;\n      flex-shrink: 0;\n    }\n    .bs988-cart-frete-msg {\n      font-size: 13px;\n      margin-bottom: 8px;\n      color: var(--bs988-cor-texto);\n    }\n    .bs988-cart-frete-msg strong { color: var(--bs988-cor-cta); }\n    .bs988-cart-frete-track {\n      height: 6px;\n      background: #e0e8e2;\n      border-radius: 3px;\n      overflow: hidden;\n    }\n    .bs988-cart-frete-fill {\n      height: 100%;\n      background: var(--bs988-cor-cta);\n      border-radius: 3px;\n      width: 0%;\n      transition: width var(--bs988-anim);\n    }\n\n    /* ====== Timer ====== */\n    .bs988-cart-timer {\n      background: var(--bs988-cor-cta);\n      color: #fff;\n      text-align: center;\n      padding: 10px;\n      font-weight: 600;\n      font-size: 14px;\n      flex-shrink: 0;\n    }\n    .bs988-cart-timer[hidden] { display: none; }\n\n    /* ====== Body (scroll) ====== */\n    .bs988-cart-body {\n      flex: 1;\n      overflow-y: auto;\n      overscroll-behavior: contain;\n      padding: 16px 20px;\n    }\n    .bs988-cart-items {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n    }\n\n    /* ====== Item ====== */\n    .bs988-cart-item {\n      display: grid;\n      grid-template-columns: 70px 1fr auto;\n      gap: 12px;\n      padding-bottom: 16px;\n      border-bottom: 1px solid var(--bs988-cor-borda);\n    }\n    .bs988-cart-item:last-child {\n      border-bottom: 0;\n      padding-bottom: 0;\n    }\n    .bs988-cart-item-image {\n      width: 70px;\n      height: 70px;\n      object-fit: cover;\n      border-radius: 6px;\n      background: var(--bs988-cor-cinza-claro);\n      display: block;\n    }\n    .bs988-cart-item-image-placeholder {\n      width: 70px;\n      height: 70px;\n      background: var(--bs988-cor-cinza-claro);\n      border-radius: 6px;\n    }\n    .bs988-cart-item-info {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      min-width: 0;\n    }\n    .bs988-cart-item-name {\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 1.3;\n      display: -webkit-box;\n      /* 3 linhas: kits do Avané carregam a composição completa no nome\n         (padrão de 14/08/2026) — 2 linhas truncava */\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      margin: 0;\n    }\n    .bs988-cart-item-controls {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      width: 100%;\n    }\n    .bs988-cart-qty-minus,\n    .bs988-cart-qty-plus {\n      width: 28px;\n      height: 28px;\n      border: 1px solid var(--bs988-cor-borda);\n      background: #fff;\n      border-radius: 50%;\n      cursor: pointer;\n      font-size: 16px;\n      line-height: 1;\n      padding: 0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: var(--bs988-cor-texto);\n    }\n    .bs988-cart-qty-minus:disabled,\n    .bs988-cart-qty-plus:disabled {\n      opacity: 0.35;\n      cursor: not-allowed;\n    }\n    .bs988-cart-qty-display {\n      min-width: 28px;\n      text-align: center;\n      font-weight: 500;\n      font-size: 14px;\n    }\n    /* v6.1 (14/08/2026, desenho Jones Road): sem coluna do X — o preço fecha\n       a linha do stepper e o nome ganha a largura toda. Remover = "−" em\n       qty=1 (vira lixeira). */\n    .bs988-cart-item-price {\n      font-weight: 600;\n      font-size: 14px;\n      white-space: nowrap;\n      margin-left: auto;\n    }\n\n    /* ====== Empty state ====== */\n    .bs988-cart-empty {\n      text-align: center;\n      padding: 40px 20px;\n      color: var(--bs988-cor-cinza);\n      font-size: 15px;\n    }\n    .bs988-cart-empty[hidden] { display: none; }\n\n    /* ====== Footer ====== */\n    .bs988-cart-footer {\n      border-top: 1px solid var(--bs988-cor-borda);\n      padding: 16px 20px;\n      background: #fff;\n      flex-shrink: 0;\n    }\n    .bs988-cart-cupom-area { margin-bottom: 12px; }\n    .bs988-cart-cupom-input {\n      width: 100%;\n      padding: 10px 12px;\n      border: 1px solid var(--bs988-cor-borda);\n      border-radius: 6px;\n      font-size: 14px;\n      font-family: inherit;\n      color: var(--bs988-cor-texto);\n      background: #fff;\n    }\n    .bs988-cart-cupom-input:focus {\n      outline: none;\n      border-color: var(--bs988-cor-cta);\n    }\n    .bs988-cart-cupom-aviso {\n      font-size: 12px;\n      line-height: 1.35;\n      color: var(--bs988-cor-cinza);\n      margin-top: 6px;\n    }\n    .bs988-cart-cupom-input-wrap { display: flex; gap: 8px; }\n    .bs988-cart-cupom-input-wrap .bs988-cart-cupom-input { flex: 1; }\n    .bs988-cart-cupom-aplicar {\n      flex-shrink: 0;\n      padding: 0 14px;\n      border: 1px solid var(--bs988-cor-borda);\n      border-radius: 6px;\n      background: #f5f5f5;\n      color: var(--bs988-cor-texto);\n      font-size: 14px;\n      font-weight: 600;\n      font-family: inherit;\n      cursor: pointer;\n    }\n    .bs988-cart-descontos-row {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 8px;\n      margin-bottom: 12px;\n    }\n    .bs988-cart-descontos-label { font-size: 15px; }\n    .bs988-cart-cupom-chip {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      margin-right: auto;\n      margin-left: 10px;\n      padding: 3px 6px 3px 10px;\n      border: 1px solid var(--bs988-cor-borda);\n      border-radius: 999px;\n      background: #f5f5f5;\n      font-size: 13px;\n      font-weight: 600;\n      line-height: 1;\n    }\n    .bs988-cart-cupom-remove {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 18px;\n      height: 18px;\n      padding: 0;\n      border: 0;\n      border-radius: 999px;\n      background: transparent;\n      color: #888;\n      font-size: 13px;\n      line-height: 1;\n      cursor: pointer;\n    }\n    .bs988-cart-cupom-remove:hover { color: var(--bs988-cor-texto); }\n    .bs988-cart-descontos-value {\n      font-size: 15px;\n      font-weight: 600;\n      white-space: nowrap;\n    }\n    .bs988-cart-subtotal-row {\n      display: flex;\n      justify-content: space-between;\n      align-items: baseline;\n      margin-bottom: 12px;\n    }\n    .bs988-cart-subtotal-label { font-size: 15px; }\n    .bs988-cart-subtotal-value {\n      font-weight: 700;\n      font-size: 18px;\n    }\n    .bs988-cart-checkout {\n      display: block;\n      width: 100%;\n      padding: 14px;\n      background: var(--bs988-cor-cta);\n      color: #fff;\n      border: 0;\n      border-radius: 6px;\n      font-size: 16px;\n      font-weight: 600;\n      cursor: pointer;\n      margin-bottom: 8px;\n      font-family: inherit;\n    }\n    .bs988-cart-checkout:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n    .bs988-cart-continuar {\n      display: block;\n      width: 100%;\n      padding: 8px;\n      background: transparent;\n      color: var(--bs988-cor-texto);\n      border: 0;\n      cursor: pointer;\n      font-size: 14px;\n      font-family: inherit;\n      text-decoration: underline;\n    }\n\n    /* ====== Badge — botão de abrir carrinho ======\n       z-index gigante pra ficar acima de chat widgets (Tawk, Jivo, Crisp,\n       Messenger, etc) que costumam usar 99999+. */\n    .bs988-open-cart {\n      position: fixed;\n      top: 20px;\n      right: 20px;\n      z-index: 2147483646;\n      width: 56px;\n      height: 56px;\n      border-radius: 50%;\n      background: var(--bs988-cor-badge-rosa);\n      border: 0;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n      color: #fff;\n      padding: 0;\n    }\n    .bs988-open-cart:hover { filter: brightness(1.05); }\n    .bs988-open-cart svg {\n      width: 24px;\n      height: 24px;\n    }\n    .bs988-cart-count {\n      position: absolute;\n      top: -4px;\n      right: -4px;\n      background: #fff;\n      color: var(--bs988-cor-badge-rosa);\n      font-size: 11px;\n      font-weight: 700;\n      min-width: 20px;\n      height: 20px;\n      border-radius: 10px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 0 6px;\n      box-sizing: border-box;\n      box-shadow: 0 0 0 2px var(--bs988-cor-badge-rosa);\n    }\n    .bs988-cart-count[data-qty="0"] { display: none; }\n\n    /* ====== Body lock no iOS (aplicado via JS) ======\n       Não usar width:100% aqui — interfere no margin:auto da página,\n       jogando o conteúdo pra esquerda quando o drawer abre.\n       left:0 + right:0 define o containing block mantendo a\n       centralização original do conteúdo via margin auto. */\n    body.bs988-locked {\n      position: fixed;\n      left: 0;\n      right: 0;\n    }\n  `;
  const HTML_TEMPLATE = `\n    <dialog class="bs988-cart-drawer" aria-labelledby="bs988-cart-title-h">\n      <div class="bs988-cart-header">\n        <h2 class="bs988-cart-title" id="bs988-cart-title-h">Carrinho</h2>\n        <button type="button" class="bs988-cart-close" aria-label="Fechar carrinho">✕</button>\n      </div>\n\n      <div class="bs988-cart-frete-bar">\n        <div class="bs988-cart-frete-msg"></div>\n        <div class="bs988-cart-frete-track">\n          <div class="bs988-cart-frete-fill"></div>\n        </div>\n      </div>\n\n      <div class="bs988-cart-timer" hidden></div>\n\n      <div class="bs988-cart-body">\n        <div class="bs988-cart-items"></div>\n        <div class="bs988-cart-empty" hidden>Seu carrinho está vazio.</div>\n      </div>\n\n      <div class="bs988-cart-footer">\n        <div class="bs988-cart-cupom-area" hidden></div>\n        <div class="bs988-cart-subtotal-row">\n          <span class="bs988-cart-subtotal-label">Subtotal</span>\n          <span class="bs988-cart-subtotal-value">R$ 0,00</span>\n        </div>\n        <button type="button" class="bs988-cart-checkout" disabled>Finalizar compra</button>\n        <button type="button" class="bs988-cart-continuar">Continuar comprando</button>\n      </div>\n    </dialog>\n\n    <button type="button" class="bs988-open-cart" aria-label="Abrir carrinho">\n      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">\n        <circle cx="9" cy="21" r="1"/>\n        <circle cx="20" cy="21" r="1"/>\n        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>\n      </svg>\n      <span class="bs988-cart-count" data-qty="0">0</span>\n    </button>\n  `;
  function injetaCSS() {
    if (document.getElementById("bs988-cart-styles")) return;
    const style = document.createElement("style");
    style.id = "bs988-cart-styles";
    style.textContent = CSS_TEMPLATE;
    document.head.appendChild(style);
  }
  function injetaHTML() {
    if (document.querySelector(".bs988-cart-drawer")) return;
    const wrapper = document.createElement("div");
    wrapper.innerHTML = HTML_TEMPLATE.trim();
    Array.from(wrapper.children).forEach(function(child) {
      document.body.appendChild(child);
    });
  }
  let elDialog, elBadge, elContador, elFreteMsg, elFreteFill, elTimer, elBody, elItems, elEmpty, elCupomArea, elSubtotalValue, elCheckout;
  function cacheElementos() {
    elDialog = document.querySelector(".bs988-cart-drawer");
    elBadge = document.querySelector(".bs988-open-cart");
    elContador = document.querySelector(".bs988-cart-count");
    elFreteMsg = elDialog.querySelector(".bs988-cart-frete-msg");
    elFreteFill = elDialog.querySelector(".bs988-cart-frete-fill");
    elTimer = elDialog.querySelector(".bs988-cart-timer");
    elBody = elDialog.querySelector(".bs988-cart-body");
    elItems = elDialog.querySelector(".bs988-cart-items");
    elEmpty = elDialog.querySelector(".bs988-cart-empty");
    elCupomArea = elDialog.querySelector(".bs988-cart-cupom-area");
    elSubtotalValue = elDialog.querySelector(".bs988-cart-subtotal-value");
    elCheckout = elDialog.querySelector(".bs988-cart-checkout");
  }
  const formatadorMoeda = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
  });
  function formataMoeda(v) {
    return formatadorMoeda.format(typeof v === "number" ? v : 0);
  }
  let timerSegundosRestantes = TIMER_SEGUNDOS;
  let timerHandle = null;
  function renderTimerTexto() {
    if (!elTimer) return;
    const m = Math.floor(timerSegundosRestantes / 60);
    const s = timerSegundosRestantes % 60;
    const mm = m < 10 ? "0" + m : String(m);
    const ss = s < 10 ? "0" + s : String(s);
    elTimer.textContent = mm + ":" + ss + " para finalizar seu pedido!";
  }
  function startTimer() {
    if (timerHandle) return;
    timerHandle = setInterval(function() {
      timerSegundosRestantes--;
      if (timerSegundosRestantes <= 0) timerSegundosRestantes = TIMER_SEGUNDOS;
      renderTimerTexto();
    }, 1e3);
  }
  function stopTimer() {
    if (timerHandle) {
      clearInterval(timerHandle);
      timerHandle = null;
    }
  }
  function resetTimer() {
    timerSegundosRestantes = TIMER_SEGUNDOS;
    renderTimerTexto();
  }
  function manageTimer() {
    if (!elTimer) return;
    if (getTotalQty() > 0) {
      elTimer.removeAttribute("hidden");
      renderTimerTexto();
      startTimer();
    } else {
      elTimer.setAttribute("hidden", "");
      stopTimer();
    }
  }
  function renderBadge() {
    if (!elContador) return;
    const qty = getTotalQty();
    elContador.textContent = qty > 99 ? "99+" : String(qty);
    elContador.setAttribute("data-qty", String(qty));
  }
  function renderSubtotal() {
    if (!elSubtotalValue) return;
    elSubtotalValue.textContent = formataMoeda(getSubtotalLiquido());
  }
  function renderCupom() {
    if (!elCupomArea) return;
    elCupomArea.replaceChildren();
    if (getTotalQty() === 0) {
      elCupomArea.hidden = true;
      return;
    }
    elCupomArea.hidden = false;
    if (cupomAplicado) {
      const st = statusCupom(cupomAplicado);
      const row = document.createElement("div");
      row.className = "bs988-cart-descontos-row";
      const label = document.createElement("span");
      label.className = "bs988-cart-descontos-label";
      label.textContent = "Descontos";
      const chip = document.createElement("span");
      chip.className = "bs988-cart-cupom-chip";
      const tag = document.createElement("span");
      tag.textContent = "🏷";
      const code = document.createElement("span");
      code.textContent = cupomAplicado;
      const rem = document.createElement("button");
      rem.type = "button";
      rem.className = "bs988-cart-cupom-remove";
      rem.setAttribute("aria-label", "Remover cupom");
      rem.textContent = "✕";
      chip.appendChild(tag);
      chip.appendChild(code);
      chip.appendChild(rem);
      const val = document.createElement("span");
      val.className = "bs988-cart-descontos-value";
      if (st.estado === "ok") val.textContent = "-" + formataMoeda(st.desconto); else if (st.estado === "frete") val.textContent = "Frete grátis";
      row.appendChild(label);
      row.appendChild(chip);
      row.appendChild(val);
      elCupomArea.appendChild(row);
      if (st.estado === "minimo" || st.estado === "desconhecido") {
        const aviso = document.createElement("div");
        aviso.className = "bs988-cart-cupom-aviso";
        aviso.textContent = st.estado === "minimo" ? "Faltam " + formataMoeda(st.falta) + " para usar este cupom (mínimo de " + formataMoeda(st.minimo) + ")" : "O desconto será validado no checkout.";
        elCupomArea.appendChild(aviso);
      }
    } else {
      const wrap = document.createElement("div");
      wrap.className = "bs988-cart-cupom-input-wrap";
      const inp = document.createElement("input");
      inp.type = "text";
      inp.className = "bs988-cart-cupom-input";
      inp.placeholder = "Cupom de desconto";
      inp.setAttribute("autocomplete", "off");
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "bs988-cart-cupom-aplicar";
      btn.textContent = "Aplicar";
      wrap.appendChild(inp);
      wrap.appendChild(btn);
      elCupomArea.appendChild(wrap);
    }
  }
  function aplicaCupomDigitado() {
    if (!elCupomArea) return;
    const inp = elCupomArea.querySelector(".bs988-cart-cupom-input");
    const v = inp ? String(inp.value || "").trim() : "";
    if (!v) return;
    cupomAplicado = v.toUpperCase();
    render();
  }
  function renderFreteGratis() {
    if (!elFreteMsg || !elFreteFill) return;
    const subtotal = getSubtotal();
    const meta = FRETE_GRATIS_META_REAIS;
    const st = statusCupom(cupomAplicado);
    const cupomDaFrete = CUPONS[normalizaCupom(cupomAplicado)];
    if (cupomDaFrete && cupomDaFrete.f && st.estado !== "minimo") {
      elFreteMsg.innerHTML = "🎉 <strong>FRETE GRÁTIS</strong> pelo cupom!";
      elFreteFill.style.width = "100%";
      return;
    }
    if (subtotal >= meta) {
      elFreteMsg.innerHTML = "🎉 Você ganhou <strong>FRETE GRÁTIS</strong>!";
      elFreteFill.style.width = "100%";
    } else {
      elFreteMsg.innerHTML = "Faltam <strong>" + formataMoeda(meta - subtotal) + "</strong> para frete grátis";
      const pct = subtotal / meta * 100;
      elFreteFill.style.width = Math.max(0, Math.min(100, pct)) + "%";
    }
  }
  function renderCheckoutBtn() {
    if (!elCheckout) return;
    elCheckout.disabled = getTotalQty() === 0;
  }
  function renderItens() {
    if (!elItems || !elEmpty) return;
    elItems.replaceChildren();
    const skus = Object.keys(estado);
    if (skus.length === 0) {
      elEmpty.removeAttribute("hidden");
      return;
    }
    elEmpty.setAttribute("hidden", "");
    skus.forEach(function(sku) {
      const cfg = PRODUTOS[sku];
      if (!cfg) return;
      const qty = estado[sku];
      const total = cfg.preco * qty;
      const itemEl = document.createElement("div");
      itemEl.className = "bs988-cart-item";
      itemEl.dataset.sku = sku;
      if (cfg.t) {
        const img = document.createElement("img");
        img.className = "bs988-cart-item-image";
        img.src = cfg.t;
        img.alt = cfg.nome;
        img.width = 70;
        img.height = 70;
        img.loading = "lazy";
        itemEl.appendChild(img);
      } else {
        const ph = document.createElement("div");
        ph.className = "bs988-cart-item-image-placeholder";
        itemEl.appendChild(ph);
      }
      const info = document.createElement("div");
      info.className = "bs988-cart-item-info";
      const nameEl = document.createElement("p");
      nameEl.className = "bs988-cart-item-name";
      nameEl.textContent = cfg.nome;
      info.appendChild(nameEl);
      const ctrls = document.createElement("div");
      ctrls.className = "bs988-cart-item-controls";
      const btnMinus = document.createElement("button");
      btnMinus.type = "button";
      btnMinus.className = "bs988-cart-qty-minus";
      btnMinus.dataset.sku = sku;
      if (qty === 1) {
        btnMinus.innerHTML = SVG_LIXEIRA;
        btnMinus.setAttribute("aria-label", "Remover " + cfg.nome + " do carrinho");
      } else {
        btnMinus.textContent = "−";
        btnMinus.setAttribute("aria-label", "Diminuir quantidade de " + cfg.nome);
      }
      const qtyDisp = document.createElement("span");
      qtyDisp.className = "bs988-cart-qty-display";
      qtyDisp.textContent = String(qty);
      const btnPlus = document.createElement("button");
      btnPlus.type = "button";
      btnPlus.className = "bs988-cart-qty-plus";
      btnPlus.dataset.sku = sku;
      btnPlus.setAttribute("aria-label", "Aumentar quantidade de " + cfg.nome);
      btnPlus.textContent = "+";
      if (qty >= QTY_MAX_POR_SKU) btnPlus.disabled = true;
      ctrls.appendChild(btnMinus);
      ctrls.appendChild(qtyDisp);
      ctrls.appendChild(btnPlus);
      const priceEl = document.createElement("span");
      priceEl.className = "bs988-cart-item-price";
      priceEl.textContent = formataMoeda(total);
      ctrls.appendChild(priceEl);
      info.appendChild(ctrls);
      itemEl.appendChild(info);
      elItems.appendChild(itemEl);
    });
  }
  function render() {
    if (!elDialog) return;
    const scrollTop = elBody ? elBody.scrollTop : 0;
    renderItens();
    renderCupom();
    renderSubtotal();
    renderBadge();
    renderFreteGratis();
    renderCheckoutBtn();
    manageTimer();
    if (elBody) elBody.scrollTop = scrollTop;
  }
  function isClickNoBackdrop(event) {
    if (event.target !== elDialog) return false;
    const r = elDialog.getBoundingClientRect();
    const dentro = event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
    return !dentro;
  }
  function attachHandlers() {
    elDialog.addEventListener("click", function(event) {
      const t = event.target;
      if (t.closest(".bs988-cart-close")) {
        fechaCart();
        return;
      }
      if (t.closest(".bs988-cart-continuar")) {
        fechaCart();
        return;
      }
      const bPlus = t.closest(".bs988-cart-qty-plus");
      if (bPlus) {
        const sku = bPlus.dataset.sku;
        updateQty(sku, (estado[sku] || 0) + 1);
        render();
        return;
      }
      const bMinus = t.closest(".bs988-cart-qty-minus");
      if (bMinus) {
        const sku = bMinus.dataset.sku;
        updateQty(sku, (estado[sku] || 0) - 1);
        render();
        return;
      }
      if (t.closest(".bs988-cart-cupom-remove")) {
        cupomAplicado = "";
        render();
        return;
      }
      if (t.closest(".bs988-cart-cupom-aplicar")) {
        aplicaCupomDigitado();
        return;
      }
      if (t.closest(".bs988-cart-checkout")) {
        finaliza();
        return;
      }
      if (isClickNoBackdrop(event)) {
        fechaCart();
        return;
      }
    });
    elBadge.addEventListener("click", function() {
      abreCart();
    });
    window.addEventListener("storage", function(event) {
      if (event.key !== STORAGE_KEY) return;
      log("Carrinho atualizado em outra aba — re-sincronizando.");
      estado = carregaCarrinho();
      render();
    });
    elDialog.addEventListener("keydown", function(event) {
      if (event.key === "Enter" && event.target.closest(".bs988-cart-cupom-input")) {
        event.preventDefault();
        aplicaCupomDigitado();
      }
    });
    log("Handlers conectados.");
  }
  let scrollYSalvo = 0;
  function abreCart() {
    if (!pronto) {
      abrirAoPronto = true;
      return;
    }
    if (!elDialog || elDialog.open) return;
    scrollYSalvo = window.scrollY || 0;
    document.body.style.top = "-" + scrollYSalvo + "px";
    document.body.classList.add("bs988-locked");
    document.documentElement.classList.add("bs988-cart-aberto");
    try {
      elDialog.showModal();
    } catch (e) {
      warn("Falha ao abrir dialog:", e);
      document.body.classList.remove("bs988-locked");
      document.documentElement.classList.remove("bs988-cart-aberto");
      document.body.style.top = "";
    }
  }
  function fechaCart() {
    if (!elDialog || !elDialog.open) return;
    elDialog.close();
  }
  function attachDrawerLifecycle() {
    elDialog.addEventListener("close", function() {
      document.body.classList.remove("bs988-locked");
      document.documentElement.classList.remove("bs988-cart-aberto");
      document.body.style.top = "";
      window.scrollTo({
        top: scrollYSalvo,
        left: 0,
        behavior: "instant"
      });
      log("Drawer fechado, scroll restaurado em", scrollYSalvo);
    });
  }
  function buildYampiUrl(carrinho, cupomInput) {
    const partes = [];
    const invalidos = [];
    Object.keys(carrinho).forEach(function(sku) {
      const cfg = PRODUTOS[sku];
      const qty = carrinho[sku];
      if (!qty || qty <= 0) return;
      if (!cfg || !cfg.token) {
        invalidos.push(sku);
        return;
      }
      partes.push(encodeURIComponent(cfg.token) + ":" + qty);
    });
    if (invalidos.length) {
      warn("SKU sem token de checkout:", invalidos.join(", "));
      return null;
    }
    if (partes.length === 0) return null;
    let url = DOMINIO_YAMPI + "/r/" + partes.join(",");
    const params = paramsCheckout();
    const cupomLimpo = cupomInput ? codigoParaCheckout(cupomInput) : "";
    let qs;
    if (params) {
      params.delete("promocode");
      if (cupomLimpo) params.set("promocode", cupomLimpo);
      qs = params.toString();
    } else {
      qs = cupomLimpo ? "promocode=" + encodeURIComponent(cupomLimpo) : "";
    }
    if (qs) url += "?" + qs;
    return url;
  }
  function finaliza() {
    if (getTotalQty() === 0) return;
    const url = buildYampiUrl(estado, cupomAplicado);
    if (!url) {
      warn("Não foi possível montar a URL da Yampi — carrinho com item inválido.");
      if (elCheckout) {
        const original = elCheckout.textContent;
        elCheckout.textContent = "Erro — recarregue a página";
        elCheckout.disabled = true;
        setTimeout(function() {
          elCheckout.textContent = original;
          elCheckout.disabled = false;
        }, 3e3);
      }
      return;
    }
    log("Redirecionando para Yampi:", url);
    window.location.href = url;
  }
  function publicAdd(chave, qty, _imgOverride) {
    const sku = resolveSku(chave);
    if (!sku) {
      warn("SKU desconhecido (BSSlideCart.add):", chave);
      return false;
    }
    const ok = addItem(sku, qty || 1);
    if (ok) {
      trackAddToCart(sku, qty || 1);
      resetTimer();
      render();
    }
    return ok;
  }
  function publicRemove(chave) {
    removeItem(resolveSku(chave));
    render();
  }
  function publicUpdateQty(chave, qty) {
    updateQty(resolveSku(chave), qty);
    render();
  }
  function publicClear() {
    clearCart();
    render();
  }
  window.BSSlideCart = {
    version: VERSAO,
    supported: true,
    open: abreCart,
    close: fechaCart,
    add: publicAdd,
    remove: publicRemove,
    updateQty: publicUpdateQty,
    clear: publicClear,
    get: getCart,
    subtotal: getSubtotal,
    totalQty: getTotalQty,
    checkout: finaliza,
    checkoutUrl: function() {
      return buildYampiUrl(estado, cupomAplicado);
    },
    urlDe: function(chave, qty) {
      return urlYampiSingleProduto(chave, qty || 1);
    },
    pronto: function() {
      return pronto;
    },
    produto: function(chave) {
      const s = resolveSku(chave);
      return s ? PRODUTOS[s] : null;
    },
    resolve: resolveSku,
    catalogo: function() {
      return PRODUTOS;
    },
    regraCupom: function(codigo) {
      const r = CUPONS[normalizaCupom(codigo)];
      return r ? {
        t: r.t,
        v: r.v,
        min: r.min || 0,
        f: r.f ? 1 : 0
      } : null;
    },
    seletor: function(familia) {
      const s = SELETORES[familia];
      return s ? JSON.parse(JSON.stringify(s)) : null;
    },
    cfg: function() {
      return {
        freteGratisMin: FRETE_GRATIS_META_REAIS,
        parcelas: PARCELAS_MAX,
        fatorParcelamento: FATOR_PARCELAMENTO,
        descontoAssinatura: DESCONTO_ASSINATURA
      };
    },
    viewContent: viewContentPagina,
    trackAddToCart: trackAddToCart,
    cupom: function(codigo) {
      if (codigo === undefined) return cupomAplicado;
      cupomAplicado = codigo ? String(codigo).trim().toUpperCase() : "";
      render();
      return cupomAplicado;
    }
  };
  function paginaComCompra() {
    if (typeof window.BS_QTYS !== "undefined") return true;
    const p = window.location.pathname;
    return p === "/" || p.indexOf("/products/") === 0;
  }
  function init() {
    try {
      resolveCupomInicial();
      processaPostCheckout();
      window.addEventListener("pageshow", function(event) {
        if (!event.persisted) return;
        log("Página restaurada do bfcache — re-processando post-checkout.");
        if (processaPostCheckout()) {
          render();
        }
      });
      if (!paginaComCompra()) {
        pronto = true;
        log("Slidecart v" + VERSAO + " pronto (sem UI: página sem compra).");
        return;
      }
      injetaCSS();
      injetaHTML();
      cacheElementos();
      attachHandlers();
      attachDrawerLifecycle();
      render();
      pronto = true;
      if (abrirAoPronto) {
        abrirAoPronto = false;
        abreCart();
      }
      log("Slidecart v" + VERSAO + " pronto.");
    } catch (e) {
      console.error("[bs-cart] init() falhou — degradando para redirect direto.", e);
      degradado = true;
      window.BSSlideCart.supported = false;
      window.BSSlideCart.open = function() {};
      window.BSSlideCart.close = function() {};
      try {
        stopTimer();
        const lixo = document.querySelectorAll(".bs988-cart-drawer, .bs988-open-cart, #bs988-cart-styles");
        for (let i = 0; i < lixo.length; i++) lixo[i].remove();
        document.body.classList.remove("bs988-locked");
        document.documentElement.classList.remove("bs988-cart-aberto");
        document.body.style.top = "";
      } catch (limpezaErro) {
        warn("Falha ao limpar o DOM do drawer na degradação:", limpezaErro);
      }
      window.BSSlideCart.add = function(chave, qty) {
        if (!cupomResolvido) {
          try {
            resolveCupomInicial();
          } catch (_) {}
        }
        const url = urlYampiSingleProduto(chave, qty || 1);
        if (url) {
          window.location.href = url;
          return true;
        }
        return false;
      };
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();